import Vue from 'vue'
import VueI18n from 'vue-i18n'
import store from '@/store/modules/language'

Vue.use(VueI18n)

const messages = {
  en_US: require('./data/en_US.json'),
  fr_FR: require('./data/fr_FR.json')
}

const dateTimeFormats = {
  'en-US': {
    short: {
      year: 'numeric', month: 'short', day: 'numeric'
    },
    long: {
      year: 'numeric', month: 'long', day: 'numeric'
    }
  },
  'fr-FR': {
    short: {
      year: 'numeric', month: 'short', day: 'numeric'
    },
    long: {
      year: 'numeric', month: 'long', day: 'numeric'
    }
  }
}

export default new VueI18n({
  locale: store.state.locale,
  fallbackLocale: store.state.fallbackLocale,
  messages,
  dateTimeFormats
})



// WEBPACK FOOTER //
// ./src/i18n/index.js